"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disable = exports.enable = exports.debug = void 0;
const debugLib = require("debug");
exports.debug = debugLib('snyk-go-plugin');
function enable() {
    debugLib.enable('snyk-go-plugin');
}
exports.enable = enable;
function disable() {
    debugLib.disable();
}
exports.disable = disable;
//# sourceMappingURL=debug.js.map